import SelectKngCatalog from './src/main.vue';

/* istanbul ignore next */
SelectKngCatalog.install = function(Vue) {
  Vue.component(SelectKngCatalog.name, SelectKngCatalog);
};

export default SelectKngCatalog;
